import has from 'lodash/has';
import { useTheme } from 'styled-components';
import { getFontColor } from '~/helpers/getColors';
import getImageProperties from '~/helpers/getImageProperties';
import { HeadlineLevel } from '../../atoms/Headline/Headline';
import { processLineBreaks } from './Fact.helpers';
import {
  FactContent,
  FactFigure,
  FactHeader,
  FactHeadline,
  FactText,
  FactsCard,
  FactsGrid,
  PictureStyled,
} from './Fact.styles';
import useIsMobile from '~/hooks/useIsMobile';

// ToDo: Consider refactoring this element to use background-image css-property instead of img-Tag
/**
 * @param {FactGridProps} props
 * @returns {React.ReactElement} The rendered component
 */
export const FactGrid = ({ facts }) => {
  const theme = useTheme();
  const isMobile = useIsMobile({ contextKey: 'hero' });
  const count = facts.length;
  return (
    <FactsGrid $count={count}>
      {facts.slice(0, 4).map((fact, index) => {
        const {
          className,
          style = 'LIGHT',
          figure,
          highlightText,
          text,
          backgroundImage,
          narrow = false,
        } = fact;
        const hasMobileImage = !!(
          backgroundImage &&
          isMobile &&
          has(backgroundImage, 'url')
        );
        const fontColor = getFontColor(theme, style);

        const processedFigure = processLineBreaks(figure);
        const processedHighlightText = processLineBreaks(highlightText);
        const processedText = processLineBreaks(text);

        return (
          <FactsCard
            key={index}
            $count={count}
            $index={index}
            $factStyle={style}
          >
            {backgroundImage && (
              <PictureStyled
                urls={getImageProperties(
                  {
                    xl: backgroundImage.url,
                    md: backgroundImage.url,
                    xs: backgroundImage.url,
                  },
                  'facts',
                )}
                alt={backgroundImage.alt}
              />
            )}
            <FactContent $hasMobileImage={hasMobileImage}>
              <FactHeader $narrow={narrow}>
                <FactFigure level={HeadlineLevel.h3} $fontColor={fontColor}>
                  {processedFigure}
                </FactFigure>
                <FactHeadline level={HeadlineLevel.h4} $fontColor={fontColor}>
                  {processedHighlightText}
                </FactHeadline>
              </FactHeader>
              {processedText && (
                <FactText $fontColor={fontColor}>{processedText}</FactText>
              )}
            </FactContent>
          </FactsCard>
        );
      })}
    </FactsGrid>
  );
};
